import { DateTime } from 'luxon'
import { IanaZone, IsoDate, IsoInstant, LocalTime } from '../types'

export const fromDateTime = (dt: DateTime): IsoInstant => IsoInstant.parse(dt.toUTC().toISO({ suppressMilliseconds: true }))

export const toLocalTime = (dt: DateTime): LocalTime => LocalTime.parse(dt.toFormat('HH:mm'))

export const localFromDateTime = (dt: DateTime): LocalTime => LocalTime.parse(dt.set({ second: 0, millisecond: 0 }).toISOTime({ suppressSeconds: true, suppressMilliseconds: true, includeOffset: false }))

export const wallTimeToInstant = (d: IsoDate, t: LocalTime, zone: IanaZone) => DateTime.fromISO(`${d}T${t}`, { zone })